import React from 'react';
import { SessionData } from '../domain/Session';  // Import the existing SessionData interface

interface UserInfoProps {
    sessionData?: SessionData;  // Use the existing SessionData interface
}

// Component to extract initials and display user info
const UserInfo: React.FC<UserInfoProps> = ({ sessionData }) => {

    // Function to extract initials from the user's display name
    const getInitials = (name: string) => {
        const nameParts = name.split(' ');
        const initials = nameParts.map(part => part[0]).join('');
        return initials.toUpperCase();
    };

    return (
        <div className="user-info">
            {/* Circle with initials */}
            <div className="user-initials-circle">
                {getInitials(sessionData!!.factors.user?.display_name || '')}
            </div>
            {/* User email */}
            <div className="user-email">
                {sessionData!!.factors.user?.login_name || ''}
            </div>
        </div>
    );
};

export default UserInfo;
